import debug from 'debug'

export const log = debug('portal')

export const track = (eventName: string, payload: any, userId?: string) => {
  if (!navigator.serviceWorker?.controller) return
  navigator.serviceWorker.controller.postMessage({
    eventName,
    payload,
    userId,
  })
}
